// extracted by mini-css-extract-plugin
export default {"screen":"screen_screen__54S7F"};